const Aparthotels = "Aparthotels";
const Apartments = "Apartments";
const Business = "Business";
const Campsites = "Campsites";
const Couple = "Couple";
const Family = "Family";
const Friend = "Friends";
const Hostels = "Hostels";
const Hotels = "Hotels";
const Resorts = "Resorts";
const Restaurants = "Restaurants";
const en = {
	"{num} reviews": "{num} reviews",
	"<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} in {location}",
	"All languages": "All languages",
	"All traveler types": "All traveler types",
	Aparthotels: Aparthotels,
	Apartments: Apartments,
	"Arrow icon": "Arrow icon",
	"B&Bs": "B&Bs",
	"based on {number} reviews": "based on {number} reviews",
	Business: Business,
	Campsites: Campsites,
	Couple: Couple,
	Family: Family,
	Friend: Friend,
	"Highlighted reviews": "Highlighted Reviews",
	Hostels: Hostels,
	Hotels: Hotels,
	"Information icon": "Information icon",
	"No reviews found": "No reviews found",
	"Pet-friendly": "Pet-friendly",
	"Posted on {reviewer}": "Posted on {reviewer}",
	"Read Reviews": "Read Reviews",
	Resorts: Resorts,
	Restaurants: Restaurants,
	"Review Summary": "Review Summary",
	"Reviews by Source": "Reviews by Source"
};

export { Aparthotels, Apartments, Business, Campsites, Couple, Family, Friend, Hostels, Hotels, Resorts, Restaurants, en as default };
//# sourceMappingURL=en.uysKZ0wY.js.map
